// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/.pnpm/css-loader@7.1.5_webpack@5.111.1/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --ds-z-index-1: 1;
    --ds-z-index-10: 10;
    /* Component specific aliases */
    --ds-calendar-z-index: var(--ds-z-index-1);
    --ds-combobox-list-z-index: var(--ds-z-index-1);
    --ds-context-menu-z-index: var(--ds-z-index-1);
    --ds-menu-z-index: var(--ds-z-index-1);
    --ds-toast-z-index: var(--ds-z-index-1);
    --ds-tooltip-z-index: var(--ds-z-index-10);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
